import React, { useState } from "react";
import MyTextBox from "../../common/elements/myTextbox";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { openNotification } from "../../common/elements/myNotification";
import { addHospitalDischarge } from "../../api/CareEventSCPApi";

const CareHospitalDischargeAdd = ({ editRecord, callback }) => {
  const [formData, setFormData] = useState(
    editRecord?.guid
      ? {
          ...editRecord,
          modifiedBy: sessionStorage.getItem("userName"),
        }
      : editRecord
  );
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [pageError, setPageError] = useState({});
  const [disable, setDisable] = useState(false);

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setPageError({ ...pageError, [name]: value ? "" : "Required" });
  };

  const handleDateChange = (fieldName, dateString) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: dateString ? dateString : "",
    }));

    if (fieldName === "hospitalDischargeDate") {
      const deceasedDate = dateString ? dayjs(dateString) : null;
      const admitDate = formData.hospitalAdmissionDate
        ? dayjs(formData.hospitalAdmissionDate)
        : null;
      if (admitDate && deceasedDate && deceasedDate.isBefore(admitDate)) {
        setPageError({
          ...pageError,
          hospitalDischargeDate:
            "Discharge date cannot be before admission date",
        });
      } else {
        setPageError({
          ...pageError,
          hospitalDischargeDate: "",
        });
      }
    } else {
      setPageError((prevErrors) => ({
        ...prevErrors,
        [fieldName]: dateString ? "" : "Required",
      }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPageError({});
    let pageErrorTemp = {};

    if (!formData?.hospitalName) {
      pageErrorTemp.hospitalName = "Required";
    }

    if (!formData?.hospitalTelephone) {
      pageErrorTemp.hospitalTelephone = "Required";
    } else if (!isPhoneValid) {
      pageErrorTemp.hospitalTelephone = "Invalid phone number";
    }

    if (!formData?.hospitalAdmissionDate) {
      pageErrorTemp.hospitalAdmissionDate = "Required";
    }

    if (!formData?.hospitalDischargeDate) {
      pageErrorTemp.hospitalDischargeDate = "Required";
    }

    if (!formData?.hospitalDischargeDx) {
      pageErrorTemp.hospitalDischargeDx = "Required";
    }

    if (!formData?.locationDischargedTo) {
      pageErrorTemp.locationDischargedTo = "Required";
    }
    const dischargeDate = formData.hospitalDischargeDate
      ? dayjs(formData.hospitalDischargeDate)
      : null;
    const admitDate = formData.hospitalAdmissionDate
      ? dayjs(formData.hospitalAdmissionDate)
      : null;
    if (admitDate && dischargeDate && dischargeDate.isBefore(admitDate)) {
      pageErrorTemp.hospitalDischargeDate =
        "Discharge date cannot be before admission date";
    }

    if (Object.keys(pageErrorTemp).length > 0) {
      setPageError(pageErrorTemp);
      return;
    }

    setDisable(true);
    onSave(e);
  };

  const onSave = async (e) => {
    try {
      const response = await addHospitalDischarge(formData);
      if (response?.status === 200 && !formData?.guid) {
        openNotification(
          "success",
          "Added",
          "Hospital Discharge Template Added Successfully!"
        );
      } else if (formData?.guid) {
        openNotification(
          "success",
          "Updated",
          "Hospital Discharge Template Updated Successfully!"
        );
      } else {
        openNotification(
          "error",
          "Error",
          "Hospital Discharge Template Failed to Add!"
        );
      }
      setFormData(editRecord);
      setDisable(false);
      callback(response);
    } catch (e) {
      return e;
    }
  };

  return (
    <div className="tw-relative tw-px-2">
      <div className="form-group tw-mb-3 tw-mr-16 tw-pr-2">
        <MyTextBox
          label={"Hospital Name"}
          value={formData?.hospitalName}
          errorMessage={pageError?.hospitalName}
          setValue={(e) => handleInputChange("hospitalName", e.target.value)}
          maxLength={100}
        />
      </div>
      <div className="form-group tw-mb-3 tw-mr-16 tw-pr-2">
        <MyTextBox
          label={"Hospital Telephone#"}
          value={formData?.hospitalTelephone}
          errorMessage={pageError?.hospitalTelephone}
          setValue={(e) =>
            handleInputChange("hospitalTelephone", e.target.value)
          }
          isPhoneNumber={true}
          onValidChange={(e) => setIsPhoneValid(e)}
        />
      </div>
      <div className="col-md-11 col-lg-11 form-group">
        <div className="tw-flex">
          <label className="tw-font-bold" htmlFor="dateTime">
            Hospital Admission Date
          </label>
        </div>
        <DatePicker
          use12Hours
          className="form-control tw-mb-3"
          onChange={(date, dateString) =>
            handleDateChange("hospitalAdmissionDate", dateString)
          }
          format={"YYYY-MM-DD"}
          value={
            formData?.hospitalAdmissionDate
              ? dayjs(formData.hospitalAdmissionDate)
              : ""
          }
          style={{
            border: pageError?.hospitalAdmissionDate ? "1px solid red" : "",
          }}
        />
      </div>
      <div className="col-md-11 col-lg-11 form-group">
        <div className="tw-flex">
          <label className="tw-font-bold" htmlFor="dateTime">
            Hospital Discharge Date
          </label>
        </div>
        <DatePicker
          use12Hours
          className="form-control tw-mb-3"
          onChange={(date, dateString) =>
            handleDateChange("hospitalDischargeDate", dateString)
          }
          format={"YYYY-MM-DD"}
          value={
            formData?.hospitalDischargeDate
              ? dayjs(formData.hospitalDischargeDate)
              : ""
          }
          style={{
            border: pageError?.hospitalDischargeDate ? "1px solid red" : "",
          }}
        />
        {pageError?.hospitalDischargeDate !== "Required" && (
          <span
            className="text-danger"
            style={{ fontWeight: "normal", paddingLeft: "5px" }}
          >
            {pageError?.hospitalDischargeDate}
          </span>
        )}
      </div>
      <div className="form-group tw-mb-3 tw-mr-16 tw-pr-2">
        <MyTextBox
          label={"Hospital Discharge Dx"}
          value={formData?.hospitalDischargeDx}
          errorMessage={pageError?.hospitalDischargeDx}
          setValue={(e) =>
            handleInputChange("hospitalDischargeDx", e.target.value)
          }
          maxLength={100}
        />
      </div>
      <div className="form-group tw-mb-3 tw-mr-16 tw-pr-2">
        <MyTextBox
          label={"Location Discharged To"}
          value={formData?.locationDischargedTo}
          errorMessage={pageError?.locationDischargedTo}
          setValue={(e) =>
            handleInputChange("locationDischargedTo", e.target.value)
          }
          maxLength={100}
        />
      </div>
      <div className="form-group tw-mb-3 tw-mr-16 tw-pr-2">
        <MyTextBox
          label={"Discharge Instructions"}
          value={formData?.dischargeInstructions}
          setValue={(e) =>
            handleInputChange("dischargeInstructions", e.target.value)
          }
          maxLength={100}
        />
      </div>
      <div className="form-group tw-mr-16 tw-pr-2">
        <label htmlFor="selectedOption" className="fw-bold">
          MedEx Notes / Message
        </label>
        <TextArea
          className="form-control"
          maxLength={"1000"}
          value={formData?.medxNotes}
          onChange={(e) => handleInputChange("medxNotes", e.target.value)}
        />
      </div>
      <div className="form-group tw-fixed tw-top-2 tw-right-10">
        <button
          className={!disable ? "btn btn-success" : "btn btn-success disabled"}
          onClick={onSubmit}
        >
          {editRecord?.guid ? "Update" : "Save"}
        </button>
        <button
          className="btn btn-secondary tw-ml-4"
          onClick={() => callback(false)}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default CareHospitalDischargeAdd;
